import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import kebabCase from 'lodash/kebabCase';
import noop from 'lodash/noop';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import InnerHTML from '@Components/InnerHTML';
import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon } from '@els/els-react--button';

import './ExportModalContentTooltip.scss';

function ExportModalContentTooltip({ header, name, text }) {
  const showCasDisclaimer = !Auth.isFeatureEnabled(FEATURES.disableCasNumberCta) && (name === 'contains:all' || name === 'contains:no');
  return (
    <Flyout
      className="exportModal__tooltip"
      flyout={
        <div className="exportModal__tooltip_content">
          {/* eslint-disable-next-line react/no-danger */}
          <InnerHTML tag="div" html={text} data-testid="export-modal-tooltip-text" />
          {showCasDisclaimer && (
            <div className="exportModal__tooltip_content_casDisclaimer casDisclaimer">
              <svg className="casDisclaimer__icon">
                <use xlinkHref="#icon-cas-number" />
              </svg>
              <span className="casDisclaimer__text">
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                Please note, CAS Registry Numbers that are retrieved using the button "Retrieve CAS RN" cannot be exported.
              </span>
            </div>
          )}
        </div>
      }
      shouldCloseOnESC
      showCloseButton
      placement="bottom-start"
      pointerType="primary">
      <ButtonWithIcon
        sprite="InformationOutlineCircle"
        iconOnly
        type="link"
        linkIconSize="xs"
        className={cn('exportModal__tooltip_button', 'e2e-dropdown', `e2e-${kebabCase(header)}`)}
        onClick={noop}>
        {header}
      </ButtonWithIcon>
    </Flyout>
  );
}

ExportModalContentTooltip.propTypes = {
  header: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.string,
};

export default ExportModalContentTooltip;
